import { ProgramSelection } from "@up/application-fields";

import type { TLibraryTheme } from "@up/data";
import type { ReactNode } from "react";

export function ProgramSelectionPage({
  bottom,
  libraryTheme,
}: {
  bottom: () => ReactNode;
  libraryTheme: TLibraryTheme;
}) {
  return (
    <ProgramSelection
      bottom={bottom}
      primaryButtonClass={libraryTheme.buttonPrimaryClass}
      supportEmail={libraryTheme.supportEmail}
    />
  );
}
